/**
 * Date-extensions locale English (Canada) [en-ca]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('en-ca', {
    monthNames: ['January','February','March','April','May','June','July','August','September','October','November','December'],
    monthShortNames: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
    dayNames: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
    dayShortNames: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
});
